<style scoped>
    .icon{
        cursor: pointer;
    }
    .invoice-picture /deep/ .ivu-modal-close .ivu-icon-ios-close{
        font-size: 50px;
        color: white;
        font-weight: bold;
        background: rgba(55,55,55,.1);
        border-radius: 50%;
    }
</style>
<template>
    <div>
        <Icon class="icon" type="ios-image-outline" :size="size" @click="showPicture"></Icon>
        <Modal class="invoice-picture" fullscreen footer-hide :z-index="1101" v-model="show_picture">
            <div v-if="invoice.id">
                <div class="text-center" v-if="!img_loaded">
                    <Icon type="ios-image-outline" size="400"></Icon>
                    <h3>发票加载中...</h3>
                </div>
                <div v-if="picture_url" :style="image_wrapper_style">
                    <img ref="image" :src="picture_url" :style="image_style" @load="imgLoad">
                </div>
            </div>
            <Spin fix v-if="loading"></Spin>
        </Modal>
    </div>
</template>
<script>
    import InvoiceUtil from '@/views/invoice/libs/util.js';
    export default {
        props: {
            invoice_id: {
                type: Number,
                required: true
            },
            size: {
                type: [Number, String],
                default: 14
            }
        },
        data(){
            return {
                show_picture: false,
                loading: false,
                img_loaded: false,
                invoice: {},
                invoice_file: {},
                ori_width: 100,
                ori_height: 100,
                orientation: 0
            }
        },
        computed: {
            picture_url(){
                if(this.invoice_file && this.invoice_file.oss_path){
                    return Util.publicOSSUrl(this.invoice_file.oss_path);
                }else{
                    return '';
                }
            },
            region(){
                let region = [0,0,0,0];
                if(this.invoice.region){
                    region = JSON.parse(this.invoice.region);
                }
                return region;
                // return this.invoice.region ? JSON.parse(this.invoice.region) : [0,0,0,0];
            },
            image_wrapper_style(){
                const width = this.region[2] - this.region[0];
                const height = this.region[3] - this.region[1];
                const rotate = this.invoice.orientation ? this.invoice.orientation : 0;
                let scale = 1;
                let translate_x = '0';
                let translate_y = '0';
                const window_width = window.innerWidth;
                const window_height = window.innerHeight;
                const changed_direction = Math.round(rotate / 90 % 2);
                if(changed_direction){
                    if(height > window_width){
                        scale = window_width / height;
                    }
                    if(width * scale > window_height){
                        translate_x = `${(width * scale - window_height) / 2}px`;
                        if(rotate === 90){
                            translate_x = `-${translate_x}`;
                        }
                    }
                }else{
                    if(width > window_width){
                        scale = window_width / width;
                    }
                    if(height * scale > window_height){
                        translate_y = `${(height * scale - window_height) / 2}px`;
                        if(rotate === 180){
                            translate_y = `-${translate_y}`;
                        }
                    }
                }

                return {
                    'position': 'absolute',
                    'top': '50%',
                    'left': '50%',
                    'overflow': 'hidden',
                    'width': `${width}px`,
                    'height': `${height}px`,
                    'transform': `translate(-50%, -50%) scale(${scale}) rotate(-${rotate}deg) translate(${translate_x}, ${translate_y})`
                }
            },
            image_style(){
                let start_x = this.region[0];
                let start_y = this.region[1];
                return {
                    'position': 'absolute',
                    'top': `-${start_y}px`,
                    'left': `-${start_x}px`,
                }
            }
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            showPicture(){
                this.show_picture = true;
                if(this.loading) return;
                this.loading = true;
                Util.ajax.get(Util.api.get_invoice_picture, {
                    params: {
                        id: this.invoice_id
                    }
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    if(res.code === 1){
                        let data = res.data;
                        this.invoice = data.invoice;
                        this.invoice_file = data.invoice_file;
                    }else{
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            },
            imgLoad(){
                this.img_loaded = true;
                this.ori_width = this.$refs.image.naturalWidth;
                this.ori_height = this.$refs.image.naturalHeight;
            }
        }
    }
</script>
